module.exports = "/_next/static/images/f5cad3483095481f98fdc125f3b6e350-ppf-lg.png.webp";